import React from 'react';

const ResumeCard = ({ title, subTitle, result, des }) => {
  return (
    <div className="w-full h-1/3 group flex">
      <div className="w-10 h-[6px] bgOpacity mt-16 relative">
        <span className="absolute w-5 h-5 rounded-full -top-2 -left-3 flex justify-center items-center bg-black bg-opacity-60 border border-gray-700 group-hover:border-designColor transition-colors duration-300 shadow-shadowOne">
          <span className="w-3 h-3 rounded-full bg-bodyColor inline-flex group-hover:bg-designColor duration-300 group-hover:shadow-neon"></span>
        </span>
      </div>
      <div className="w-full bg-[#191b1e] bg-opacity-80 hover:bg-opacity-100 duration-300 rounded-2xl p-4 lgl:px-10 flex flex-col justify-center gap-6 lgl:gap-10 border border-transparent hover:border-r-gray-800 shadow-shadowOne relative overflow-hidden">
        {/* Glow backdrop on hover */}
        <div className="absolute inset-0 bg-gradient-to-r from-designColor/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        <div className="flex flex-col lgl:flex-row justify-between gap-4 lgl:gap-0 lgl:items-center z-10">
          <div>
            <h3 className="text-xl md:text-2xl font-bold group-hover:text-designColor duration-300 font-titleFont">
              {title}
            </h3>
            <p className="text-sm mt-2 text-gray-400 group-hover:text-white duration-300 font-bodyFont">
              {subTitle}
            </p>
          </div>
          <div>
            <p className="px-4 py-2 text-designColor bg-black bg-opacity-25 rounded-lg flex justify-center items-center shadow-shadowOne text-sm font-medium group-hover:shadow-neon transition-shadow duration-300">
              {result}
            </p>
          </div>
        </div>
        <p className="text-sm md:text-base font-medium text-gray-400 group-hover:text-gray-300 duration-300 z-10">
          {des}
        </p>
      </div>
    </div>
  );
};

export default ResumeCard;
